import { Navigate, Route, Routes } from "react-router-dom";

import { ROUTE_CONFIG } from "@/routes/config";

import { TrackerToListRedirect } from "./TrackerToListRedirect";
import { resolveLegacyTrackerTarget } from "./utils/resolveLegacyTrackerTarget";

export const LegacyProfileTrackerRoutes = () => (
	<Routes>
		<Route
			element={<Navigate replace to={resolveLegacyTrackerTarget(ROUTE_CONFIG.PROFILE_TRACKER)} />}
			path="/"
		/>
		<Route
			element={
				<Navigate
					replace
					to={resolveLegacyTrackerTarget(`${ROUTE_CONFIG.PROFILE_TRACKER}/create`)}
				/>
			}
			path="/create"
		/>
		<Route element={<TrackerToListRedirect />} path="/detail/:id" />
		<Route element={<TrackerToListRedirect />} path="/edit/:id" />
		<Route element={<TrackerToListRedirect />} path="/settings/:id" />
		<Route element={<Navigate replace to={resolveLegacyTrackerTarget("")} />} path="*" />
	</Routes>
);
